import { extendTailwindMerge } from "tailwind-merge";

/**
 * Configured twMerge that understands the project's custom text utilities.
 *
 * Without this, tailwind-merge can't distinguish custom font-size classes
 * (e.g. text-subhead-2xs, text-body-m) from custom color classes
 * (e.g. text-body-primary, text-headline) — and incorrectly drops one
 * when both appear together.
 *
 * Keep in sync with globals.css @theme definitions.
 */
export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            // display
            "display-xl",
            "display-l",
            "display-m",
            "display-s",
            // headline
            "headline-xl",
            "headline-l",
            "headline-m",
            "headline-s",
            // subhead
            "subhead-xl",
            "subhead-l",
            "subhead-m",
            "subhead-s",
            "subhead-xs",
            "subhead-2xs",
            // body
            "body-l",
            "body-m",
            "body-s",
            "body-xs",
            "body-2xs",
            // link
            "link-l",
            "link-l-mobile",
            "link-m",
            "link-m-mobile",
            "link-s",
            "link-xs",
            // custom scales
            "sw-2xl",
            "sw-xl",
            "sw-lg",
            "sw-md",
          ],
        },
      ],
      "text-color": [
        {
          text: [
            // headline colors
            "headline",
            "headline-brand-1",
            "headline-brand-2",
            "headline-eyebrow",
            // subhead color
            "subhead",
            // body colors
            "body-primary",
            "body-secondary",
            // link colors
            "link",
            "link-hover",
            "link-pressed",
            "link-visited",
            "link-visited-hover",
            "link-visited-pressed",
            "link-inline-content",
            "link-inline-content-pressed",
            "link-inline-content-visited",
            "link-inline-content-visited-pressed",
            // tab-link colors
            "tab-link",
            "tab-link-hover",
            "tab-link-pressed",
            // list-item colors
            "list-item",
            "list-item-hover",
            // button colors
            "button-primary-fill",
            "button-primary-fill-hover",
            "button-primary-fill-pressed",
            "button-primary-fill-disabled",
            "button-primary-content",
            "button-primary-content-hover",
            "button-primary-content-pressed",
            "button-primary-content-disabled",
            "button-secondary-outline",
            "button-secondary-outline-hover",
            "button-secondary-outline-pressed",
            "button-secondary-outline-disabled",
            "button-secondary-content",
            "button-secondary-content-hover",
            "button-secondary-content-pressed",
            "button-secondary-content-disabled",
            "button-tertiary-content",
            "button-tertiary-content-hover",
            "button-tertiary-content-pressed",
            "button-tertiary-content-disabled",
            "button-tertiary-arrow",
            // arrow colors
            "arrow",
            "arrow-hover",
            "arrow-pressed",
            "arrow-disabled",
            // slider colors
            "slider-pagination",
            "slider-pagination-active",
            // accordion colors
            "accordion-arrow",
            "accordion-border",
            // misc colors
            "scrollbar",
            "background",
            "background-highlight",
            "popular-search-text",
            // symbol graphic colors
            "symbol-orange-400-graphic",
            "symbol-gray-300-graphic",
            "symbol-blue-200-graphic",
            "symbol-cool-gray-600-graphic",
            "symbol-gray-100-graphic",
            "symbol-silver-300-graphic",
            "symbol-silver-400-graphic",
            // semantic alert colors
            "semantic-alert-low",
            "semantic-alert-medium",
            "semantic-alert-high",
            "semantic-alert-critical",
          ],
        },
      ],
    },
  },
});
